import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel, KeyOutlined, Check } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Stack,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    Tooltip,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import { axiosInstance } from 'utils/axios';

import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

import useFetchData from 'hooks/useFetchData';

import UpdatePayoutRequestModal from './components/UpdatePayoutRequestModal';
import BatchUpdatePayoutRequestModal from './components/BatchUpdatePayoutRequestModal';
import NewUpdatePayoutRequestModal from './components/NewUpdatePayoutRequestModal';
import BatchUpdateAllPayoutRequestModal from './components/BatchUpdateAllPayoutRequestModal';

const successAlert = (message) => {
    toast.success(message, {
        position: toast.POSITION.TOP_CENTER
    });
};

const errorAlert = (message) => {
    toast.error(message, {
        position: toast.POSITION.TOP_CENTER
    });
};

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'dateLabel', label: 'Date Label', minWidth: 170, type: 'date' },
    {
        id: 'clientName',
        label: 'Client Name',
        minWidth: 170
    },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 170 },
    { id: 'amount', label: 'Amount', minWidth: 170 },
    { id: 'estimatedProcessingFees', label: 'Processing Fees', minWidth: 170 },
    { id: 'finalAmount', label: 'Final Amount', minWidth: 120 },
    // { id: 'processingFees', label: 'Actual Processing Fees', minWidth: 170 },
    { id: 'statusName', label: 'Status', minWidth: 70 },
    { id: 'bankVendorName', label: 'Bank Vendor Name', minWidth: 170 },
    { id: 'bankAccountNumber', label: 'Bank Account Number', minWidth: 170 },
    { id: 'bankAccountHolderName', label: 'Bank Account Holder Name', minWidth: 170 },
    {
        id: 'isPayoutDaily',
        label: 'Daily Payout Job',
        minWidth: 120
    },
    { id: 'thirdPartyName', label: 'Third Party', minWidth: 170 },
    {
        id: 'createdDate',
        label: 'Created Date',
        minWidth: 170,
        type: 'date'
    },
    { id: 'userName', label: 'User Name', minWidth: 170 }
];

function createData(count, name, payout, start, end, active) {
    return { count, name, payout, start, end, active };
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const PayoutRequests = () => {
    const { data: thirdpartyList } = useFetchData('/ThirdParty');

    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true);
    const [payoutStatuses, setPayoutStatuses] = useState([]);
    const [payouts, setPayouts] = useState([]);

    const [filterPayoutFrom, setFilterPayoutFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterPayoutTo, setFilterPayoutTo] = useState(dayjs());
    const [filterPayoutClientName, setFilterPayoutClientName] = useState('');
    const [filterPayoutCustomerLoginUserName, setFilterPayoutCustomerLoginUserName] = useState('');
    const [filterPayoutStatus, setFilterPayoutStatus] = useState('');
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [customerLoginUserNamesOptions, setCustomerLoginUserNamesOptions] = useState([]);

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const [generateBtnDisabled, setGenerateBtnDisabled] = useState(false);
    const [isAllowFilterUserName, setIsAllowFilterUserName] = useState('');
    const [filterUserName, setFilterUserName] = useState('');
    const [usersList, setUsersList] = useState([]);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    //approve request start
    const approveReferralRequest = async (row) => {
        try {
            const res = await axiosInstance.post(
                `/ApprovePayoutDetailsRequest`,
                {
                    id: parseInt(row.id)
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Request Approved Successfully.');
                // fetchPayouts();
                // update the row status
                const updatedRow = { ...row };
                updatedRow['statusName'] = 'Approved';
                updatedRow['statusID'] = 2;
                setPayouts(payouts.map((item) => (item.id === row.id ? updatedRow : item)));
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //approve request end

    const fetchCustomerLoginUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/LoginUserNames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerLoginUserNamesOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Is Allow Filter UserName
    const fetchIsAllowFilterUserName = async () => {
        try {
            const res = await axiosInstance.get(`/isAllowFilterUserName`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowFilterUserName(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    //fetch customer names for autocomplete start
    const fetchUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Usernames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsersList(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //generate payout start
    const generatePayout = async () => {
        setGenerateBtnDisabled(true);
        try {
            const res = await axiosInstance.post(
                '/GeneratePayout',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('Generated payout successfully.');
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setGenerateBtnDisabled(false);
        }
    };
    //generate payout end

    //fetch payout status start
    const fetchPayoutStatuses = async () => {
        try {
            const res = await axiosInstance.get('/PayoutRequestStatus/All', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setPayoutStatuses(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch payout status end

    const [prevPages, setPrevPages] = useState([]);
    const [newPage, setNewPage] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        // if (newPage >= page) {
        //     setPage(newPage);

        //     if (!prevPages.includes(newPage)) {
        //         setPrevPages((prevPages) => [...prevPages, newPage]);
        //         setNewPage(newPage); // Update the newPage state
        //     }
        // } else {
        //     setPage(newPage);
        // }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        // setRowsPerPage(+event.target.value);
        // setPrevPages([]);
        // setPayouts([]);
        // setPage(0);
    };
    useEffect(() => {
        fetchPayouts();
    }, [newPage, rowsPerPage]);

    //fetch payouts start
    const [fetchPayoutLoading, setPayoutLoading] = useState(false);
    const fetchPayouts = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        if (!filterPayoutFrom.isValid() || !filterPayoutTo.isValid()) {
            warningAlert('Please fill the required fields.');
            return;
        }
        let fetchPayoutURL = `/PayoutRequest/All?dateLabelFrom=${filterPayoutFrom.format('YYYY-MM-DD')}&dateLabelTo=${filterPayoutTo.format(
            'YYYY-MM-DD'
        )}`;

        if (filterPayoutCustomerLoginUserName !== '') {
            fetchPayoutURL += `&customerLoginUserName=${filterPayoutCustomerLoginUserName}`;
        }
        if (filterPayoutStatus !== '') {
            fetchPayoutURL += `&statusID=${filterPayoutStatus}`;
        }
        setPayoutLoading(true);
        try {
            const res = await axiosInstance.get(fetchPayoutURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                // setPayouts((payouts) => [...payouts, ...res.data]);
                setPayouts(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setPayoutLoading(false);
        }
    };
    //fetch payouts end

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterPayoutFrom.isValid() || !filterPayoutTo.isValid()) {
            warningAlert('Please fill the required fields.');
            return;
        }
        let fetchPayoutURL = `/PayoutRequest/All?dateLabelFrom=${filterPayoutFrom.format('YYYY-MM-DD')}&dateLabelTo=${filterPayoutTo.format(
            'YYYY-MM-DD'
        )}`;

        if (filterPayoutCustomerLoginUserName !== '') {
            fetchPayoutURL += `&customerLoginUserName=${filterPayoutCustomerLoginUserName}`;
        }
        if (filterPayoutStatus !== '') {
            fetchPayoutURL += `&statusID=${filterPayoutStatus}`;
        }

        try {
            const res = await axiosInstance.get(fetchPayoutURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `PayoutRequests_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    const BatchApprove = () => {
        const [batchStartDate, setBatchStartDate] = useState('');
        const [batchEndDate, setBatchEndDate] = useState('');
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false); // Initialize as false
        const [loading, setLoading] = useState(false); // Add loading state

        const submitInsertBatchApproveDate = async () => {
            if (batchStartDate === '' || batchEndDate === '') {
                warningAlert('Please fill all required fields.');
                return;
            }

            setLoading(true); // Set loading to true
            setInsertBtnDisabled(true); // Disable the button during submission

            const formattedBatchStartDate = dayjs(batchStartDate).format('YYYY-MM-DD');
            const formattedBatchEndDate = dayjs(batchEndDate).format('YYYY-MM-DD');
            try {
                const res = await axiosInstance.post(
                    '/BatchApprove/PendingPayout',
                    {
                        startDate: formattedBatchStartDate,
                        endDate: formattedBatchEndDate
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    handleClose(); // Close the modal on success
                    fetchPayouts();
                    successAlert('Batch Approve Success.');
                } else {
                    errorAlert('Something went wrong');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false); // Reset loading state after request is completed
                setInsertBtnDisabled(false); // Re-enable the button
            }
        };

        return (
            <>
                {/* <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginBottom: '20px',
                        marginRight: '20px',
                        marginTop: '20px'
                    }}
                >
                    Batch Approve
                </Button> */}

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Batch Approve
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box id="modal-modal-description" sx={{}}>
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Start Date :
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={batchStartDate}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setBatchStartDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                End Date :
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={batchEndDate}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setBatchEndDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertBatchApproveDate()}
                                disabled={insertBtnDisabled}
                            >
                                Approve Batch
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };

    const [batchUpdateLoading, setBatchUpdateLoading] = useState(false);
    const batchUpdate = async () => {
        setBatchUpdateLoading(true);
        try {
            const res = await axiosInstance.post(
                '/BatchUpdate/PayoutRequest/Pending',
                {
                    dateFrom: filterPayoutFrom.format('YYYY-MM-DD'),
                    dateTo: filterPayoutTo.format('YYYY-MM-DD')
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Batch Update Success.');
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setBatchUpdateLoading(false);
        }
    };

    //payout table start
    function StickyHeadTable() {
        const [checkedRows, setCheckedRows] = useState([]);
        const token = useSelector(selectCurrentToken);

        useEffect(() => {
            const storedCheckedRows = localStorage.getItem('checkedRows');
            if (storedCheckedRows) {
                setCheckedRows(JSON.parse(storedCheckedRows));
            }
        }, []);

        const handleCheckboxChange = async (id) => {
            try {
                const res = await axiosInstance.put(
                    `/Payout/${id}/Approve`,
                    { id: id },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200 && res.data === true) {
                    const updatedCheckedRows = checkedRows.includes(id)
                        ? checkedRows.filter((rowId) => rowId !== id)
                        : [...checkedRows, id];

                    // Update state and local storage
                    setCheckedRows(updatedCheckedRows);
                    localStorage.setItem('checkedRows', JSON.stringify(updatedCheckedRows));

                    successAlert('Update approve payout success.');
                    // fetchPayouts();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            }
        };

        return (
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchPayoutLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {payouts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                {columns.map((column) => {
                                                    let value = row[column.id];
                                                    if (value === true) value = <>&#9989;</>;
                                                    else if (value === false) value = <>&#10060;</>;

                                                    if (column.type && column.type === 'date') {
                                                        if (value) {
                                                            const timeString12hr = new Date(
                                                                '1970-01-01T' + value.split('T')[1] + 'Z'
                                                            ).toLocaleTimeString('en-US', {
                                                                timeZone: 'UTC',
                                                                hour12: true,
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric'
                                                            });
                                                            value = `${value.split('T')[0]} ${timeString12hr}`;
                                                        }
                                                    }
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {value}
                                                        </TableCell>
                                                    );
                                                })}
                                                {isUserAllowEdit &&
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: row.statusID == 2 ? 'none' : 'block',
                                                                alignItems: 'center',
                                                                gap: '10px'
                                                            }}
                                                        >
                                                            <Button
                                                                onClick={() => approveReferralRequest(row)}
                                                                sx={{
                                                                    border: 'none',
                                                                    backgroundColor: 'transparent',
                                                                    width: 'fit-content',
                                                                    height: 'fit-content',
                                                                    color: deepPurple[500]
                                                                }}
                                                            >
                                                                <Check />
                                                            </Button>
                                                            {/* <UpdatePayoutRequestModal payoutRequest={row} thirdParty={thirdpartyList} fetchPayoutRequest={fetchPayouts} /> */}
                                                        </Box>
                                                    </TableCell>
                                                }
                                                {isUserAllowEdit &&
                                                    <TableCell>
                                                        <BatchUpdatePayoutRequestModal row={row} fetchPayouts={fetchPayouts} filterPayoutDateFrom={filterPayoutFrom} filterPayoutDateTo={filterPayoutTo} />
                                                    </TableCell>
                                                }
                                                {isUserAllowEdit &&
                                                    <TableCell>
                                                        <NewUpdatePayoutRequestModal row={row} fetchPayouts={fetchPayouts} payoutRequestStatus={payoutStatuses}  />
                                                    </TableCell>
                                                }
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={payouts.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                )}
            </Box>
        );
    }
    //payout table end

    useEffect(() => {
        setLoading(false);

        Promise.all([
            fetchPayoutStatuses(),
            fetchPayouts(),
            fetchIsAllowFilterUserName(),
            // fetchCustomerNamesOptions(),
            fetchCustomerLoginUserNamesOptions(),
            fetchUserNamesOptions(),
            fetchIsUserAllowEdit()
        ]).catch((error) => {
            // Handle errors if any of the promises fail
            console.error('An error occurred:', error);
        });
    }, []);

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Grid container item xs={12}>
            {/* <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                <BatchApprove />
                <Button
                    onClick={() => generatePayout()}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        // marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                    disabled={generateBtnDisabled}
                >
                    Generate Payout
                </Button>
            </Box> */}
            {isUserAllowEdit &&
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                    <BatchUpdateAllPayoutRequestModal fetchPayouts={fetchPayouts} filterPayoutFrom={filterPayoutFrom} filterPayoutTo={filterPayoutTo}/>
                    {/* <BatchApprove />
                    <Button
                        variant="contained"
                        sx={{
                            display: 'flex',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => UpperBatchUpdate()}
                        disabled={batchUpdateLoading}
                    >
                        Batch Update
                    </Button> */}
                </Box>
            }

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '20px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>Label From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPayoutFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPayoutFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>Label To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPayoutTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPayoutTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer Login User Name :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={filterPayoutCustomerLoginUserName}
                            onChange={(event, newValue) => {
                                setFilterPayoutCustomerLoginUserName(newValue);
                            }}
                            inputValue={filterPayoutCustomerLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setFilterPayoutCustomerLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNamesOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                {/* User Name */}
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            User Name :
                        </Typography>

                        <Select
                            disabled={!isAllowFilterUserName}
                            displayEmpty
                            value={filterUserName}
                            onChange={(e) => setFilterUserName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Username
                            </MenuItem>
                            {usersList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.userName}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid> */}

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Status :
                        </Typography>
                        <Select displayEmpty value={filterPayoutStatus} onChange={(e) => setFilterPayoutStatus(e.target.value)}>
                            <MenuItem value="">Select Payout Status</MenuItem>
                            {payoutStatuses.map((item, index) => (
                                <MenuItem value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    gap: '15px',
                    width: '50%',
                    marginLeft: 'auto'
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '30px'
                    }}
                    onClick={() => fetchPayouts()}
                    disabled={filterBtnDisabled}
                >
                    Filter
                </Button>
                
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => exportDataAsXlsx()}
                    disabled={filterBtnDisabled}
                >
                    Export Data
                </Button>
            </Box>

            <StickyHeadTable />
        </Grid>
    );
};

export default PayoutRequests;
